var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessGreenCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3770_11312)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.25,
    fill: "white",
    stroke: "#1C614C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7346 16.1667C10.5227 16.1667 10.3186 16.075 10.1693 15.9109L8.05963 13.5921C7.75407 13.2563 7.75954 12.7176 8.07179 12.3889C8.38386 12.0601 8.88475 12.0664 9.19049 12.4018L10.6563 14.013L14.7441 8.17265C15.0069 7.79741 15.5024 7.72156 15.852 8.00455C16.2011 8.28717 16.2709 8.82056 16.0083 9.19597L11.3666 15.8275C11.2279 16.0256 11.0158 16.1488 10.7856 16.1648C10.7686 16.1661 10.7517 16.1667 10.7346 16.1667Z",
    fill: "#1C614C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3770_11312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessGreenCheckmark);
export default __webpack_public_path__ + "static/media/success-green-checkmark.58531e5a97f87a8f338d4bfd88e1574b.svg";
export { ForwardRef as ReactComponent };